//* Utilitários puros de busca inteligente (case-insensitive, sem acentos, por tokens)

//* Normaliza texto para busca: minúsculas + remoção de acentos (NFD)
export const normalizeText = (value: string | null | undefined): string =>
    (value ?? '')
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')

//* Quebra a consulta em tokens normalizados e não vazios
export const tokenize = (query: string): string[] => normalizeText(query).split(/\s+/).filter(Boolean)

//* Todo token da consulta deve ser substring do haystack (AND, ordem irrelevante)
//  Ex: "JOAO SILVA" casa com "João Pedro da Silva"
export const matchesTokens = (normalizedHaystack: string, tokens: string[]): boolean =>
    tokens.every(token => normalizedHaystack.includes(token))

//* Monta um haystack normalizado a partir de partes possivelmente nulas
export const buildHaystack = (parts: Array<string | null | undefined>): string =>
    normalizeText(parts.filter(Boolean).join(' '))
